import { useEffect, useState } from "react";
import "./ResponseDetailsRating.css";
import { FormResponseExtended, Question } from "effno-core";
import { RatingStar } from "../shared/RatingStar";
import { Response } from "effno-core";

type ResponseDetailsRatingProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
}

export const ResponseDetailsRating = ({question, responses} : ResponseDetailsRatingProps) => {

    let scores = 0;
    let scoreTotal = 0;

    const settings = question ? JSON.parse(question.settings) : {}

    const min = 1;
    const max = parseInt(settings.stars) || 5; 

    const scoreArray : string [] = [];
    for (let i = min; i <= max; i++) {
        scoreArray.push(i.toString());
    }

    const responsesArray = new Array(scoreArray.length).fill(0);

    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    
                    const responseValues = JSON.parse(response.responseValues);
                    const score = responseValues.score;
                    if (score) {
                        responsesArray[score - 1] += 1;
                        scores++;
                        scoreTotal += score;
                    }
                }

            })
        });
    }

    const avgRating = scores > 0 ? (scoreTotal / scores).toFixed(1) : 0;

    return (
        <div className="response-details-rating">
            <div className="response-details-rating-header">
                <div className="response-details-generic-stat">
                    Ratings: {scores}
                </div>
                <div className="response-details-generic-stat">
                    Average Rating: {avgRating}
                </div>
            </div>

            <div className="response-details-rating-scores">
                {scoreArray.map((score, index) => {
                    const percentage = Math.floor((responsesArray[index] / scores) * 100);
                    return (
                        <div className="response-details-rating-star">
                            <div className="response-details-rating-value">
                             {index +1 }
                            </div>                         
                            <RatingStar 
                                starNumber={index + 1}
                                starCount={scoreArray.length}
                                isMobileLayout={false}
                            />
                            <div className="response-details-rating-bar-container">
                                <div 
                                    className="response-details-rating-bar-value"
                                    style={{width: `${percentage}%`}}
                                >
                                    {" "}
                                </div>
                            </div>
                            <div className="response-details-rating-bar-responses">
                                {responsesArray[index]} responses
                            </div>
                            
                        </div>
                    )
                })}
            </div>


        </div>
    )
}